var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: !_vm.dimensionType ? "新建" : "编辑",
            width: "500px",
          },
          on: { close: _vm.handleClose },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.dimensionDataSource,
                    size: "small",
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "名称",
                        prop: "name",
                        rules: {
                          required: true,
                          message: "请输入",
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.dimensionDataSource.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dimensionDataSource,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "dimensionDataSource.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "编码",
                        prop: "code",
                        rules: {
                          required: false,
                          message: "请输入",
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          placeholder: "请输入",
                          maxlength: "6",
                          disabled: _vm.dimensionType ? true : false,
                        },
                        model: {
                          value: _vm.dimensionDataSource.code,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dimensionDataSource,
                              "code",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "dimensionDataSource.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.dimensionDataSource.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.dimensionDataSource, "status", $$v)
                          },
                          expression: "dimensionDataSource.status",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          type: "textarea",
                          rows: "5",
                        },
                        model: {
                          value: _vm.dimensionDataSource.remark,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.dimensionDataSource,
                              "remark",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "dimensionDataSource.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitData } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }